<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      :content-style="{height: '100%'}"
      :footer="false"
      @close="cancel">
    <template #header>
      {{shipmentId}}
      <gj-tag v-if="shipment.status" type="plain" shape="rectangle"
              :color="shipment.status | optionColor(FbaShipmentEnum.statusOption)"
              >
        {{shipment.status}}
      </gj-tag>
    </template>
    <template #content>
      <app-left-right
          :gutter="1"
          left-width="450px"
          :left-shadow="false"
          style="height: 100%;">
        <template #left>
          <div v-loading="baseLoading" style="height: 100%;">
            <gj-area-title>货件信息</gj-area-title>
            <div class="content-row">
                <span class="gj-label">货件名称：</span>
                <span>{{shipment.name}}</span>
            </div>
            <div class="content-row">
                <span class="gj-label">仓库：</span>
                <span>{{shipment.warehouseName | defaultShow}}</span>
            </div>
            <div class="content-row">
                <span class="gj-label">国家：</span>
                <span>
                  <template v-if="shipment.shipToCountryCode">
                     {{ shipment.shipToCountryCode | optionText(countryOption) }}
                  </template>
                  <template v-else>-</template>
                </span>
            </div>
            <div class="content-row">
                <span class="gj-label">贴标方：</span>
                <span>{{shipment.labelPrepType | optionText(FbaShipmentEnum.list_labelPrepTypeOption) | defaultShow}}</span>
            </div>
            <div class="content-row">
                <span class="gj-label">包装类型：</span>
                <span>{{shipment.areCasesRequired | optionText(FbaShipmentEnum.areCasesRequiredOption) | defaultShow}}</span>
            </div>
            <div class="content-row">
                <span class="gj-label">亚马逊仓代码：</span>
                <span>{{shipment.centerId | defaultShow}}</span>
            </div>
            <div class="content-row">
                <span class="gj-label">发货地址：</span>
                <span>{{shipFromAddress}}</span>
            </div>

          </div>
        </template>
        <template #right>
<!--  <p>{{shipment | json}}</p>-->
          <div class="right-content">
            <gj-area-title>处理货件</gj-area-title>
            <div  style="height: calc(100% - 31px);">
              <div class="handle-steps">
                <gj-steps
                    :active="curStep"
                    :steps="['检测货件内容', '选择配送服务', '上传包装明细', '标记出运']">
                </gj-steps>
              </div>
              <div class="handle-content">
                <keep-alive>
                  <component
                      v-bind:is="curStepComponent"
                      :form="form"
                      :id="id"
                      :shipment="shipment"
                      :cancel="cancel"
                      :markShipment="markShipment"
                      :previousStep="previousStep"
                      :mount-to="$el"
                      :nextStep="nextStep"
                      @markUpdate="markUpdate">
                  </component>
                </keep-alive>
              </div>
            </div>
          </div>
        </template>
      </app-left-right>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "@/minxins";
  import AppStep1 from "./steps/step-1";
  import AppStep2 from "./steps/step-2";
  import AppStep3 from "./steps/step-3";
  import AppStep4 from "./steps/step-4";
  import {getFbaShipment} from "@/api/logistics";
  import {fbaShipmentAddressMixin} from "../../../../common/logistics/mixin";
  import {FbaShipmentEnum} from "../../../../common/logistics/enum";
  import {countryOption} from "@/utils/options";

  export default {
    name: "app-handle-fba-shipment-modal",
    components: {AppStep1, AppStep2, AppStep3, AppStep4},
    mixins: [modalMixIn, fbaShipmentAddressMixin],
    props: {
      id: {
        required: true
      },
      shipmentId: {
        required: true
      }
    },
    data() {
      return {
        labelSpan: 10,
        contentSpan: 13,
        curStep: 0,
        form: {
          countryCode: null,
          shipmentStatus: null,
          areCasesRequired: null,
          shipmentType: FbaShipmentEnum.shipmentType.SPD,
          numberOfPackages: null,
          carrierName: null,
          pageType: null,
          printQuantity: null,
          items: []
        },
        FbaShipmentEnum: FbaShipmentEnum,
        baseLoading: false,
        nextStepLoading: false,
        updateFbaShipmentLoading: false,
        countryOption: countryOption,
        shipment: {},
        updated: false
      }
    },
    computed: {
      curStepComponent() {
        return `app-step-${this.curStep + 1}`;
      },
    },
    created() {
      this.baseLoading = true;
      getFbaShipment(this.id)
        .then((data) => {
          if (data) {
            this.shipment = data;
            this.form.areCasesRequired = data.areCasesRequired;
            this.form.shipmentStatus = data.status;
            if (data.transportDetails) {
              this.form.shipmentType = data.transportDetails.shipmentType;
              this.form.carrierName = data.transportDetails.carrierName;
            }
            this.form.countryCode = data.shipToCountryCode;
            this.form.numberOfPackages = data.numberOfPackages;
          }
        })
        .complete(() => this.baseLoading = false);
    },
    methods: {
      markUpdate() {
        this.updated = true;
      },
      previousStep() {
        this.curStep--;
      },
      nextStep() {
        this.curStep++;
      },
      cancel() {
        if (this.updated) {
          this.$emit('updated');
        }
        this.$gjDestroy();
      },
      markShipment() {
        this.$gjDestroy();
        this.$emit('markShipment');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-info--row {
    margin-bottom: 10px;
  }
  .right-content {
    height: 100%;
    padding-left: 10px;
  }
  .handle-content {
    display: flex;
    flex: 1;
    padding-top: 50px;
    height: calc(100% - 91px);
  }
  .gj-label--right,
  .gj-content {
    font-size: 13px;
  }
  /deep/ .el-dialog__body{
    padding: 16px 20px;
  }
  /deep/ .right-container-bg{
    padding: 0;
    width: 100%;
    height: 100%;
  }
  /deep/ .right-content{
    padding-left: 0;
  }
  /deep/ .right-container{
    padding-left: 20px;
    flex: 2;
  }
  /deep/ .left-container{
    box-sizing: border-box;
    padding-right: 20px;
    flex: 1;
    min-width: auto !important;
    max-width: auto !important;
  }

  .content-row {
    line-height: 32px;
    display: flex;
    color: #333;
    font-size: 12px;
    .gj-label {
      text-align: right;
      color: #666;
      width: 98px;
    }
  }
</style>

